<div class="legal-container">
    <h1>Privacy Policy</h1>
    <div class="last-updated">Last Updated: December 12, 2025</div>

    <p>Your privacy is critically important to us. This Privacy Policy explains how BabyMonitor.live collects, uses, and
        protects your information.</p>

    <h2>1. Information We Collect</h2>
    <ul>
        <li><strong>Account Information:</strong> When you sign up, we collect your email address and authentication
            tokens via Google Sign-In.</li>
        <li><strong>Usage Metadata:</strong> We collect anonymous data about session duration, connection stability, and
            feature usage to improve the Service.</li>
        <li><strong>Thumbnails:</strong> We may temporarily store static image thumbnails from the video feed to display
            on your dashboard for room identification. These are stored securely and associated only with your account.
        </li>
    </ul>

    <h2>2. Video & Audio Data</h2>
    <p><strong>Your live video and audio feeds are End-to-End Encrypted (WebRTC)</strong> when connected peer-to-peer.
        We do not store, record, or have access to your ongoing live stream content on our servers.</p>

    <h2>3. How We Use Your Information</h2>
    <p>We use the collected information to:</p>
    <ul>
        <li>Provide and maintain the Service.</li>
        <li>Authenticate your access.</li>
        <li>Analyze usage patterns to fix bugs and improve performance.</li>
        <li>Display targeted advertising (see Section 4).</li>
    </ul>

    <h2>4. Advertising & Third Parties</h2>
    <p>We may work with third-party advertising partners to show ads.
        These partners may use cookies or similar technologies to show you ads based on your interests. We do not sell
        your personal data to these advertisers.</p>

    <h2>5. Data Selling Policy</h2>
    <p><strong>We do not sell your personal data</strong> (email, video content, private logs) to third parties. Our
        business model relies on subscriptions and advertising, not on selling user data.</p>

    <h2>6. Changes to This Privacy Policy</h2>
    <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy
        Policy on this page. You are advised to review this Privacy Policy periodically for any changes.</p>

    <h2>7. Contact Us</h2>
    <p>If you have any questions about this Privacy Policy, please contact us at support@babymonitor.live.</p>
</div>
